import React, { useEffect, useState } from 'react';
import { getHeaderNotification, getFaqsData } from './../utils/endpoints';
import HeaderNotification from './components/headerNotification';
import Faqs from './components/faq';
import Loading from './components/loading';
import Header from './components/header';
import Footer from './components/footer';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet';

const CSR = () => {
  const [headerNotificationData, setHeaderNotificationData] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const faqsData = await getFaqsData();
        const headerData = await getHeaderNotification();

        setHeaderNotificationData(headerData);
        setFaqs(faqsData || []);
      } catch (error) {
        setError(error);
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return (
    <div className='error_modal'>
      <div className='error_modal-wrapper'>
        <img  src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Statue of Belief"/>
        <h1>We’re making a few improvements to serve you better. Please check back shortly for an enhanced experience.</h1>
        <button class="reload-btn" onClick={() => window.location.reload()}>
            Reload Page
        </button>
      </div>
    </div>
    );
  }

  return (
    <div>
      <Helmet>
        <title>CSR | biggest shiva statue in Rajasthan</title>
      </Helmet>

      <HeaderNotification compData={headerNotificationData} />
      <Header />

      <section className='section-breadcrumb'>
        <Container>
          <ul>
            <li><a href="/">Home</a></li>
            <li>CSR</li>
          </ul>
          <h1>CSR</h1>
        </Container>
      </section>

      <section className='section-about'>
        <Container>
          <Row>
            <Col lg={7}>
              <h2>Serving Compassion Through Care and Nourishment</h2>
              <p>
                At Statue of Belief, our CSR initiatives are rooted in compassion, environmental responsibility, and community welfare. <strong>Aadesh Gopalan</strong> operates across an expansive <strong>25 bigha campus</strong>, providing shelter and dedicated care to <strong>over 1,000 cows</strong>, primarily nurturing <strong>three indigenous breeds</strong> in a well-managed and healthy environment. Strengthening our commitment to sustainable practices, the gaushala also includes a <strong>biogas plant</strong> utilizing dairy by-products and a <strong>vermicompost unit</strong> that converts organic waste into valuable natural compost.
              </p>
              <p>Complementing this effort, <strong>Annakshetra</strong> serves free meals as a continuous act of service, ensuring nourishment and hospitality for visitors, devotees, and those in need.</p>
            </Col>

            <Col lg={5}>
              <img
                src="https://www.theindianthing.com/shiva-statue/wp-content/uploads/2023/06/about-thumb-01-1-1.webp"
                loading="lazy"
                alt="Statue of Belief"
                className='img-fluid'
              />
            </Col>
          </Row>
        </Container>
      </section>

      <Faqs compData={faqs.slice(0, 5)} />

      <Container>
        {faqs.length > 5 && (
          <div className='faq_viewMore'>
            <a href="/faqs">View more</a>
          </div>
        )}
      </Container>

      <Footer />
    </div>
  );
};

export default CSR;